var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpireBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.896,
    height: 58.428,
    viewBox: "0 0 43.896 58.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M40.609,20.863a20.008,20.008,0,1,0-14.2,24.472,20.008,20.008,0,0,0,14.2-24.472M23.346,33.653a8.085,8.085,0,1,1,5.741-9.89,8.086,8.086,0,0,1-5.741,9.89",
    transform: "translate(2.611 12.418)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M17.488,7.906A8.765,8.765,0,1,1,7.906.043a8.763,8.763,0,0,1,9.582,7.863",
    transform: "translate(0 0)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpireBlackLogo);
export default __webpack_public_path__ + "static/media/spireBlackLogo.5a6481337ca1380bbc9e661820c92621.svg";
export { ForwardRef as ReactComponent };